import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M7.9 5.625H6.86c-.92 0-1.667.746-1.667 1.667v7.083c0 .92.746 1.667 1.667 1.667h7.083c.92 0 1.667-.747 1.667-1.667V7.292c0-.92-.746-1.667-1.667-1.667H12.9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12.067 6.875H8.734a.833.833 0 0 1-.834-.833v-1.25c0-.46.373-.834.834-.834h3.333c.46 0 .833.373.833.834v1.25c0 .46-.373.833-.833.833Zm-3.542 3.333h3.75m-3.75 2.5h3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);